<div [ngClass]="{ 'document-picker-modal': isPickerMode }">
  @if (isPickerMode) {
  <div class="d-flex justify-content-between align-items-center p-16 pb-0! shrink-0">
    <span class="f-s-16 f-w-600">{{ dialogTitle | translate }}</span>
    <div (click)="onCancelPicker()"
      class="w-8 aspect-square d-flex justify-content-center align-items-center rounded cursor-pointer hover:bg-[var(--mat-color-light-table-hover)] hover:text-[var(--mat-sys-primary)] dark:hover:bg-[var(--striped-row-background-color)] dark:hover:text-[var(--mat-color-primary)]">
      <i-tabler name="x" class="icon-20" />
    </div>
  </div>
  }

  <div class="cardWithShadow p-[20px]" [ngClass]="{ 'picker-body': isPickerMode }">
    <div class="documents-toolbar">
      <div class="documents-toolbar-left">
        @if (config.features?.createDir) {
        <button type="button" (click)="createDir()"><i class="nxe-folder"></i>{{ 'new folder' | translate }}</button>
        }
        <button type="button" (click)="refresh()"><i class="nxe-arrows-cw"></i>{{ 'refresh' | translate }}</button>
        @if (config.features?.upload) {
        <button type="button" (click)="openUploader()"><i class="nxe-upload"></i>{{ 'upload' | translate }}</button>
        }
        @if (config.features?.download) {
        <button type="button" [disabled]="!(canDownload$ | async)" (click)="download()"><i class="nxe-download"></i>{{ 'download' | translate }}</button>
        }
        @if (config.features?.rename) {
        <button type="button" [disabled]="!(canRename$ | async)" (click)="rename()"><i class="nxe-edit"></i>{{ 'rename' | translate }}</button>
        }
        @if (config.features?.delete) {
        <button type="button" [disabled]="!(canDelete$ | async)" (click)="remove()"><i class="nxe-trash-empty"></i>{{ 'delete' | translate }}</button>
        }
      </div>
      <div class="documents-toolbar-right">
        @for (view of views; track view.name) {
        <button type="button" class="documents-toolbar-view-btn" (click)="setView(view.name)"><i class="{{ view.icon }}"></i></button>
        }
      </div>
    </div>

    <div #explorerHost class="documents-explorer" [class.picker-explorer]="isPickerMode" (contextmenu)="onContextMenu($event)" (dblclick)="onExplorerDblClick($event)">
      <nxe-explorer></nxe-explorer>
    </div>

    <input type="file" multiple hidden #contextMenuUploader (change)="handleFiles($event)" />

    @if (itemContextMenu || emptyContextMenu) {
    <div class="context-menu-backdrop" (click)="closeContextMenus()" (contextmenu)="onBackdropContextMenu($event)">
    </div>
    }

    @if (itemContextMenu) {
    <ul class="context-menu" [style.left.px]="itemContextMenu.x" [style.top.px]="itemContextMenu.y">
      @if (itemContextMenu.canDownload && config.features?.download) {
      <li (click)="download()"><i class="nxe-download"></i> {{ 'download' | translate }}</li>
      }
      @if (itemContextMenu.count === 1 && config.features?.rename) {
      <li (click)="rename()"><i class="nxe-edit"></i> {{ 'rename' | translate }}</li>
      }
      <li (click)="moveTo()"><i class="nxe-arrows-cw"></i> {{ 'move to' | translate }}</li>
      <li (click)="copyTo()"><i class="nxe-doc"></i> {{ 'copy to' | translate }}</li>
      @if (config.features?.delete) {
      <li class="danger" (click)="remove()"><i class="nxe-trash-empty"></i> {{ 'delete' | translate }}</li>
      }
    </ul>
    }

    @if (emptyContextMenu) {
    <ul class="context-menu" [style.left.px]="emptyContextMenu.x" [style.top.px]="emptyContextMenu.y">
      @if (config.features?.createDir) {
      <li (click)="createDir()"><i class="nxe-folder"></i> {{ 'new folder' | translate }}</li>
      }
      @if (config.features?.upload) {
      <li (click)="openUploader()"><i class="nxe-upload"></i> {{ 'upload' | translate }}</li>
      }
      <li (click)="refresh()"><i class="nxe-arrows-cw"></i> {{ 'refresh' | translate }}</li>
    </ul>
    }
  </div>

  @if (isPickerMode) {
  <div class="dialog-footer d-flex justify-content-end align-items-center gap-8 p-16">
    <button mat-stroked-button type="button" (click)="onCancelPicker()" class="rounded-md h-[36px]!">
      {{ 'cancel' | translate }}
    </button>
    <button mat-flat-button color="primary" type="button" [disabled]="!selectedFile" (click)="onConfirmPicker()"
      class="rounded-md h-[36px]!">
      {{ 'select' | translate }}
    </button>
  </div>
  }
</div>
